import {Brick, registerBrick} from 'olympe';
import {merge} from 'rxjs';
import {map} from 'rxjs/operators';

/**
 * This brick logs all the info about an API call
 */
export default class LogAPICallInfo extends Brick {
    /**
     * @override
     */
    setupExecution($) {
        const [ctrlFlow,
            errorFlow,
            logLevel,
            title,
            requestHeader,
            requestQuery,
            requestBody,
            requestURL,
            responseStatusCode,
            responseHeader,
            responseBody,
            other,
            stringLimiter] = this.getInputs();
        return merge($.observe(ctrlFlow), $.observe(errorFlow)).pipe(map((input) => {
            return [$.get(errorFlow),
                $.get(logLevel),
                $.get(title),
                $.get(requestHeader),
                $.get(requestQuery),
                $.get(requestBody),
                $.get(requestURL),
                $.get(responseStatusCode),
                $.get(responseHeader),
                $.get(responseBody),
                $.get(other),
                $.get(stringLimiter)];
        }));
    }

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} logLevel
     * @param {string} title
     * @param {string} requestHeader
     * @param {string} requestQuery
     * @param {string} requestBody
     * @param {string} requestURL
     * @param {number} responseStatusCode
     * @param {string} responseHeader
     * @param {string} responserBody
     * @param {string} other
     * @param {boolean} stringLimiter
     * @param {function()} forwardEvent
     */
    update($, [errorFlow, logLevel, title, requestHeader, requestQuery, requestBody, requestURL, responseStatusCode, responseHeader, responseBody, other, stringLimiter], [forwardEvent, setErrorFlow]) {
        const msg = `
        ${title}\n
        =============================\n
        Request URL : ${stringLimiter ? requestURL?.substring(0, 150) : requestURL}\n
        Request Headers : ${stringLimiter ? requestHeader?.substring(0, 150) : requestHeader}\n
        Request Query : ${stringLimiter ? requestQuery?.substring(0, 150) : requestQuery}\n
        Request Body : ${stringLimiter ? requestBody?.substring(0, 150) : requestBody}\n
        -----------------------------\n
        Response Status Code : ${responseStatusCode}\n
        Response Headers : ${stringLimiter ? responseHeader?.substring(0, 150) : responseHeader}\n
        Response Body : ${stringLimiter ? responseBody?.substring(0, 150) : responseBody}\n
        -----------------------------\n
        ${stringLimiter ? other?.substring(0, 150) : other}\n
        =============================\n`;

        switch (logLevel) {
        case 'debug':
            console.debug(msg);
            break;
        case 'info':
            console.info(msg);
            break;
        case 'warn':
            console.warn(msg);
            break;
        case 'error':
            console.error(msg);
            break;
        default:
            console.debug(msg);
            break;
        }

        if (errorFlow) {
            setErrorFlow(errorFlow);
        } else {
            forwardEvent();
        }
    }
}

registerBrick('0192e345b12830c4877b', LogAPICallInfo);
